
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_6xiez_bfzb6_5",
  "header": "awsui_header_6xiez_bfzb6_6"
};
  